import { defineComponent as _defineComponent } from 'vue'
import {computed, getCurrentInstance, onMounted, PropType, reactive, ref, watch} from "vue";
import {WebFormModel} from "capitalist-shared/src/core/model";
import {DataSaver} from "@/views/pages/profile/profile-verification";
import debounce from "debounce";


export default /*#__PURE__*/_defineComponent({
  __name: 'ModelValuesAutoSaver',
  props: {
  model: {
    type: Object as PropType<WebFormModel>,
    required: true
  },
  debounceTime: {
    type: Number,
    default: 500
  },
  saveKey: {
    type: String,
    required: true
  }
},
  emits: ['saved', 'loaded'],
  setup(__props, { expose, emit: emits }) {

const props = __props;




const model = computed(() => props.model);


const dataSaver = reactive(new DataSaver(props.saveKey ? props.saveKey : 'profile-update-form'));
const autoSave = debounce(() => {
  const values = {};
  Object.keys(model.value.values).forEach((objKey) => {
    if ((typeof model.value.values[objKey] == 'string') || (typeof model.value.values[objKey] == 'boolean')) {
      values[objKey] = model.value.values[objKey];
    }
  })
  dataSaver.save(values);
  emits('saved');
}, 500);
watch(() => model.value.getValuesHash(), (value) => {
  autoSave();
})

const modalName = computed(() => props.saveKey ? props.saveKey + '-modal' : 'profile-update-form-modal');

const touched = ref(false)
const instance = ref(getCurrentInstance());

watch(() => touched.value, (value) => {
  if (value) {
    const savedData = dataSaver.getData();
    if (savedData) {
      instance.value?.proxy?.$modal.show(modalName.value);
    }
  }
})

const touch = () => {
  if (touched.value) return;
  touched.value = true;
}

onMounted(() => {
  instance.value = getCurrentInstance() as any;
})

const goCancel = () => {
  instance.value?.proxy?.$modal.hide(modalName.value);
}

const goConfirm = () => {
  emits('loaded', dataSaver.getData() || {});
  instance.value?.proxy?.$modal.hide(modalName.value);
}

const clear = () => {
  dataSaver.clear();
}

expose({
  touch,
  clear
})

return { __sfc: true,props, model, emits, dataSaver, autoSave, modalName, touched, instance, touch, goCancel, goConfirm, clear }
}

})